import {Validator} from 'jsonschema'
import cloneDeep from 'lodash/cloneDeep'
import {useMemo} from 'react'

import {usePipelineAdditionalVcsRootsOrDraft} from '../../../EditPipelinePage.hooks'
import {getCustomAgents} from '../../../EditPipelinePage.utils'
import schemaJson from '../schema.json'
import getJsonSchemaAdditionalVcsRoot from '../utils/getJsonSchemaAdditionalVcsRoot'
import getJsonSchemaJobs from '../utils/getJsonSchemaJobs'

function useYamlSchema(currentYaml: string) {
  const additionalVcsRoots = usePipelineAdditionalVcsRootsOrDraft()
  const schema = useMemo(() => {
    const clonedSchemaJson = cloneDeep(schemaJson)
    const customAgents = getCustomAgents().map(({name}) => name)
    const additionalVcsRootNames = additionalVcsRoots.reduce((acc, {url}) => {
      const jsonSchemaAdditionalVcsRoot = getJsonSchemaAdditionalVcsRoot(url)

      return {
        ...acc,
        ...jsonSchemaAdditionalVcsRoot,
      }
    }, {})
    const {jobs, filesPublication} = getJsonSchemaJobs(currentYaml)

    // Add enum files
    if (filesPublication.length) {
      clonedSchemaJson.definitions.files.enum = filesPublication
    }

    // Add repositories
    clonedSchemaJson.definitions.repositories.properties = {
      ...clonedSchemaJson.definitions.repositories.properties,
      ...additionalVcsRootNames,
    }

    // Add enum of agents
    if (customAgents.length) {
      clonedSchemaJson.definitions.runOn.enum = [
        ...clonedSchemaJson?.definitions?.runOn?.enum,
        ...customAgents,
      ]
    }

    // Add jobs
    clonedSchemaJson.properties.jobs.properties = {
      ...clonedSchemaJson.properties.jobs.properties,
      ...jobs,
    }

    return clonedSchemaJson
  }, [additionalVcsRoots, currentYaml])
  const validator = useMemo(() => {
    const newValidator = new Validator()
    newValidator.addSchema(schema)

    return newValidator
  }, [schema])

  return {validator, schema}
}

export default useYamlSchema
